var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrimary(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 108,
    height: 108,
    viewBox: "0 0 108 108",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .a {\n                fill: #f5f5f5;\n            }\n\n            .b {\n                fill: #403f3f;\n            }\n\n            .c {\n                filter: url(#a);\n            }\n        "), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0,
    width: 108,
    height: 108,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1024 -391)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "matrix(1, 0, 0, 1, 1024, 391)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 90,
    height: 90,
    rx: 22,
    transform: "translate(9 6)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1025.8 403.574)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(58.764 52.722)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M315.917,401.28h-.026a.99.99,0,1,1,0-1.98h.026a.99.99,0,1,1,0,1.98Z",
    transform: "translate(-314.9 -399.3)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(73.683 52.722)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M430.9,401.28H428.89a.99.99,0,1,1,0-1.98H430.9a.99.99,0,0,1,0,1.98Z",
    transform: "translate(-427.9 -399.3)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(73.683 57.079)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M430.9,434.281H428.89a.99.99,0,1,1,0-1.981H430.9a.99.99,0,0,1,0,1.981Z",
    transform: "translate(-427.9 -432.3)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(73.683 61.436)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M430.9,467.28H428.89a.99.99,0,1,1,0-1.98H430.9a.99.99,0,0,1,0,1.98Z",
    transform: "translate(-427.9 -465.3)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.8 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M200.147,56.532h2.8v2.786a1.352,1.352,0,0,0,1.347,1.347H208.4a1.352,1.352,0,0,0,1.347-1.347V56.532h2.8a1.352,1.352,0,0,0,1.347-1.347V51.093a1.352,1.352,0,0,0-1.347-1.347h-2.8v-2.8A1.352,1.352,0,0,0,208.4,45.6h-4.106a1.352,1.352,0,0,0-1.347,1.347v2.8h-2.8a1.352,1.352,0,0,0-1.347,1.347V55.2A1.35,1.35,0,0,0,200.147,56.532Zm.634-4.806h3.156a1,1,0,0,0,.99-.99V47.594h2.839v3.142a1,1,0,0,0,.99.99h3.156v2.826h-3.156a1,1,0,0,0-.99.99V58.7h-2.839V55.542a1,1,0,0,0-.99-.99h-3.156Z",
    transform: "translate(-175.166 -39.579)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M133.414,334.4a4.3,4.3,0,0,0-7.684,2.047,4.239,4.239,0,0,0,.845,3.182l4.318,5.625a4.287,4.287,0,0,0,3.42,1.69,4.306,4.306,0,0,0,3.407-6.919Zm-3.71,6.06-1.558-2.033a2.331,2.331,0,0,1-.449-1.716,2.263,2.263,0,0,1,.885-1.532,2.364,2.364,0,0,1,1.413-.475,2.319,2.319,0,0,1,1.848.911s1.505,1.954,1.545,2.02Zm6.905,2.482a2.263,2.263,0,0,1-.885,1.532,2.332,2.332,0,0,1-3.261-.436l-1.545-2.02,3.7-2.812c.528.687,1.056,1.373,1.558,2.033A2.366,2.366,0,0,1,136.61,342.944Z",
    transform: "translate(-111.708 -288.783)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M88.17,312.133H84.552v-3.644a.99.99,0,1,0-1.981,0v3.644H78.756V307.8a3.64,3.64,0,0,0-3.644-3.631H65.724A3.649,3.649,0,0,0,62.08,307.8v21.68H41.734v-3.671h12.6a3.651,3.651,0,0,0,3.644-3.644V307.644A3.651,3.651,0,0,0,54.33,304H40.73a3.651,3.651,0,0,0-3.644,3.644v9.823a6.7,6.7,0,0,0-2.126-.343,6.138,6.138,0,0,0-.99.079v-5.6a.99.99,0,1,0-1.981,0v6.206a6.75,6.75,0,0,0-3.789,6.06v6.6a1,1,0,0,0,.99.99H88.157a1,1,0,0,0,.99-.99V313.124A.978.978,0,0,0,88.17,312.133ZM39.753,329.483H30.181v-5.611a4.78,4.78,0,0,1,9.559,0v5.611Zm-.687-10.972V307.644a1.674,1.674,0,0,1,1.664-1.664H54.316a1.657,1.657,0,0,1,1.664,1.664v14.537a1.674,1.674,0,0,1-1.664,1.664H41.72A6.69,6.69,0,0,0,39.066,318.511Zm37.709,10.972H64.061V307.8a1.654,1.654,0,0,1,1.664-1.65h9.388a1.662,1.662,0,0,1,1.664,1.65Zm10.4,0H78.769V314.114H87.18Z",
    transform: "translate(-27.091 -263.861)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M76.271,18.815H74.819V17.072a4.508,4.508,0,0,0-4.5-4.5h-5.77a13.6,13.6,0,0,0-27.12,0h-5.77a4.508,4.508,0,0,0-4.5,4.5v1.743H25.7c-2.944,0-5.9,1.69-5.9,5.453v5.77a7.044,7.044,0,0,0,4.912,6.694v6.589a.99.99,0,0,0,1.981,0V37.049h.132a7.016,7.016,0,0,0,6.034-3.433,7.043,7.043,0,0,0,12.094,0,7.043,7.043,0,0,0,12.094,0,7.031,7.031,0,0,0,12.081,0,7.021,7.021,0,0,0,6.047,3.433h.132V40.2a.99.99,0,1,0,1.981,0V36.732A7.027,7.027,0,0,0,82.2,30.038v-5.77c-.013-3.763-2.984-5.453-5.928-5.453ZM64.547,14.55h5.77a2.522,2.522,0,0,1,2.522,2.522v1.743H63.517A13.918,13.918,0,0,0,64.547,14.55ZM50.987,1.981A11.579,11.579,0,1,1,39.381,13.56,11.6,11.6,0,0,1,50.987,1.981ZM29.135,17.072a2.53,2.53,0,0,1,2.522-2.522h5.77a13.534,13.534,0,0,0,1.017,4.265H29.135ZM80.206,30.038a5.057,5.057,0,0,1-10.114,0,.99.99,0,1,0-1.981,0,5.05,5.05,0,0,1-10.1,0,.99.99,0,0,0-1.981,0,5.057,5.057,0,0,1-10.114,0,.99.99,0,0,0-1.981,0,5.057,5.057,0,0,1-10.114,0,.99.99,0,0,0-1.981,0,5.05,5.05,0,0,1-10.1,0v-5.77c0-3.222,3.01-3.486,3.921-3.486H39.5a13.579,13.579,0,0,0,22.974,0h13.8c.924,0,3.921.251,3.921,3.486Z",
    transform: "translate(-19.8 0)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrimary);
export default __webpack_public_path__ + "static/media/Primary.eda452d8cf95a9d39ebe0229e46fe21e.svg";
export { ForwardRef as ReactComponent };